import { Inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'moneyFormat'
})
export class MoneyFormatPipe implements PipeTransform {
    constructor(@Inject('ENV') public env: any) {}

    transform(value: number | string | { amount: number }, multiplier?: number): string {
        let floatValue: number;
        if (typeof value === 'object') {
            floatValue = parseFloat(value?.amount as any);
        } else {
            floatValue = parseFloat(value as any);
        }

        if (this.env.IS_NEW_AFC) floatValue = floatValue / 100;

        if (typeof multiplier === 'number' && multiplier > 1) {
            floatValue *= multiplier;
        }

        const decimalValue: number = !isNaN(floatValue) ? floatValue : 0;
        const locale: string = this.env.LOCALE || 'en-us';
        const minimumFractionDigits: number = this.env.MIN_DECIMAL_DIGITS ?? 2;

        return decimalValue.toLocaleString(locale, { minimumFractionDigits, maximumFractionDigits: 2 });
    }
}
